import { render, staticRenderFns } from "./CardHeadingWithIcon.vue?vue&type=template&id=413e8ee0&scoped=true&"
import script from "./CardHeadingWithIcon.vue?vue&type=script&lang=js&"
export * from "./CardHeadingWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./CardHeadingWithIcon.vue?vue&type=style&index=0&id=413e8ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e8ee0",
  null
  
)

export default component.exports